import { VersionShow } from './VersionShow';

export default {
  show: VersionShow
};
